export default {
  LOAD_STUDENT_COMPETENCY_CYCLE_LIST_START: 'LoadStudentCompetencyCycleListStart',
  LOAD_STUDENT_COMPETENCY_CYCLE_LIST_END: 'LoadStudentCompetencyCycleListEnd'
};